<template>
  <el-aside :width="!isCollapse ? '240px' : '64px'" class="menu">
    <div class="logo-wrapper">
      <div class="logo" v-show="!isCollapse">试剂管理平台</div>
    </div>
    <el-menu
          :default-active="$route.fullPath"
          class="el-menu-vertical"
          background-color="#081340"
          collapse-transition
          text-color="#fff"
          active-text-color="#00C3ED"
          :unique-opened = 'true'
          @open="handleOpen"
          @close="handleClose"
          :collapse="isCollapse"
          router>
      <el-menu-item index="/cs/index">
          <i class="el-icon-menu"></i>
          <span slot="title">首页</span>
      </el-menu-item>
      <el-submenu index="2">
          <template slot="title">
              <i class="el-icon-info"></i>
              <span>信息</span>
          </template>
          <el-menu-item index="/cs/cabinetManage">试剂柜信息</el-menu-item>
          <el-menu-item index="/cs/ParameterInformation">台账信息</el-menu-item>
          <el-menu-item index="/cs/StorageMessage">储存信息</el-menu-item>
          <el-menu-item index="/cs/purchaseMessage">购买信息</el-menu-item>
      </el-submenu>
      <el-submenu index="3">
          <template slot="title">
              <i class="el-icon-s-tools"></i>
              <span>管理</span>
          </template>
          <el-menu-item index="/gs/typingReagents">手动录入试剂</el-menu-item>
          <el-menu-item index="/gs/excelReagents">excel导入试剂</el-menu-item>
          <el-menu-item index="/gs/findMsds">MSDS查询</el-menu-item>
          <el-menu-item index="/gs/useCondition">购置情况</el-menu-item>
          <el-menu-item index="/gs/employCondition">使用情况</el-menu-item>

      </el-submenu>
    <el-submenu index="4">
        <template slot="title">
            <i class="el-icon-s-claim"></i>
            <span>试剂柜设置</span>
        </template>
        <el-menu-item index="/gs/cabinetSet/smartSaid">智能称管理</el-menu-item>
        <el-menu-item index="/gs/cabinetSet/reagentCabinet">试剂柜管理</el-menu-item>
    </el-submenu>
    <el-submenu index="5">
        <template slot="title">
            <i class="el-icon-s-home"></i>
            <span>实验室房间管理</span>
        </template>
        <el-menu-item index="/gs/laboratory/management">实验室</el-menu-item>
        <el-menu-item index="/gs/laboratory/LaboratoryRoom">实验室房间</el-menu-item>
        <el-menu-item index="/gs/laboratory/LaboratoryStaff">实验室人员</el-menu-item>
    </el-submenu>
  </el-menu>
    <div class="change-btn" :class="{mini: isCollapse}" @click="handleControl">
      <i class="el-icon-arrow-left" v-if="!isCollapse"></i>
      <i class="el-icon-arrow-right" v-else></i>
    </div>
  </el-aside>
</template>

<script type="text/ecmascript-6">
import * as VARIABLES from 'common/variables/routers'
export default {
  data () {
    return {
      isCollapse: window.innerWidth < 1200,
      VARIABLES
    }
  },
  mounted() {
    window.onresize = () => {
      this.isCollapse = window.innerWidth < 1200
    }
  },
  methods: {
    handleControl() {
      this.isCollapse = !this.isCollapse
    },
    handleOpen() {
    },
    handleClose() {
    }
  },
  components: {
    // FadeAnimate
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/mixin.styl'
@import '~common/stylus/variable.styl'

.el-menu
  border-right-width 0

.fade-enter-active
.fade-leave-active
  transition opacity .5s
.menu
  position relative
  background #081340
  min-height 100vh
  transition all .3s
  &.mini
    width 64px
  .logo-wrapper
    height 60px
    line-height 60px
    text-align center
    font-size 30px
    color #fff
    box-sizing border-box
    display flex
    justify-content center
    align-items center
    // .logo-normal
    //   box-sizing border-box
    //   padding 20px
    //   width 240px
    //   overflow hidden
    .logo
      bg('./logo.png')
      background-size 51px 32px
      background-position 0 0
      width 175px
      height 30px
      line-height 30px
      font-size 18px
      padding-left 50px
      box-sizing border-box
      color #F2F2F2
      // .text
      //   float left
      //   margin-left 10px
      //   padding-left 10px
      //   height 30px
      //   line-height 30px
      //   font-size $font-size-big
      //   border-left 1px solid #fff
    .logo-mini
        bg('./logo.png')
      width 30px
      height 30px
  .change-btn
    position fixed
    z-index 1
    width 240px
    height 48px
    line-height 48px
    bottom 0
    left 0
    text-align center
    font-size 14px
    color #fff
    background #10316b
    transition all .3s
    cursor pointer
    &.mini
      width 64px
</style>
